
import Vue from 'vue';
import Component from 'vue-class-component';
import rely from '@/nmb/oauth2/oauth2rely';
import screenfull from 'screenfull';
import { Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Message } from 'element-ui';

@Component({ components: {} })
export default class BoardHome extends Vue {
  @Getter menu: any;
  @Action getBoardMenu: Function;
  access: number = 1;
  active: string = '';
  title: string = '';
  iframeUrl: string = '';
  isFullscreen: boolean = false;
  isCollapse: boolean = false;

  created() {
    this.getBoardMenu();
  }
  mounted() {
    const element: any = document.getElementById('full-btn');
    element.addEventListener('click', () => {
      if (screenfull.isEnabled) {
        screenfull.request(document.getElementById('board-iframe') as Element);
      } else {
        Message.warning('您使用的浏览器目前不支持全屏功能！');
      }
    });
  }

  @Watch('menu.loading')
  watchMenuLoading(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      let item = null;
      if (this.menu.data && this.menu.data.length > 0 ) {
        item =  this.menu.data[0];
        if (this.menu.data[0].Type === 'file') {
          item = this.menu.data[0];
        } else {
          if (this.menu.data[0].children && this.menu.data[0].children.length > 0) {
            item = this.menu.data[0].children[0];
          }
        }
      }
      if (item) {
        this.access = item.Access;
        this.iframeUrl = item.LinkURL;
        this.title = item.Name;
        this.active = item.ID + '';
      }
    }
  }

  checkFull() {
    const isFull = document.fullscreenEnabled || (window as any).fullScreen || (document as any).webkitIsFullScreen || (document as any).msFullscreenEnabled;

    return !!isFull;
  }
  // 切换报表
  onMenuItemClick(item: any) {
    this.access = item.Access;
    this.iframeUrl = item.LinkURL;
    this.title = item.Name;
  }

  handleCollapse() {
    this.isCollapse = !this.isCollapse;
  }

}
